// user settings
export const advisoryRecord = [
  { title: '保險公司', key: 'insuCompany' },
  { title: '險種', key: 'insuType' },
  { title: '標題', key: 'title' },
  { title: '最近回應時間', key: 'replyTime' },
];

export const MeberDropdownItems = [
  { name: 'userIndex', text: '會員首頁' },
  { name: 'userOrders', text: '我的保單' },
  { name: 'userProfile', text: '資料修改' },
  { name: 'userPass', text: '密碼變更' },
  { name: 'UserHelp', text: 'Q&A' }
  // { name: 'userAdvi', text: '諮詢紀錄' },
];

export const LogoutDropdownItems = [
  { name: null, text: '登出' }
];